import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  size?: 'md' | 'xl' | undefined;
}

export const RefreshIcon = styled.span<IProps>`
  transform: translateZ(0);
  ${mixin.flex({})};
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 56px;
  width: 32px;
  height: 32px;
  transition: opacity 0.3s;

  svg {
    width: 16px;
    height: 16px;
  }

  ${props => {
    if (props.size === 'xl') {
      return css`
        width: 56px;
        height: 56px;

        svg {
          width: 22px;
          height: 22px;
        }
      `;
    }

    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('50')};
    width: ${mixin.pxToVw('32')};
    height: ${mixin.pxToVw('32')};

    svg {
      width: ${mixin.pxToVw('16')};
      height: ${mixin.pxToVw('16')};
    }

    ${props => {
      if (props.size === 'xl') {
        return css`
          width: ${mixin.pxToVw('56')};
          height: ${mixin.pxToVw('56')};

          svg {
            width: ${mixin.pxToVw('22')};
            height: ${mixin.pxToVw('22')};
          }
        `;
      }

      return null;
    }}
  }
`;
